export const CREATE_NOTIFICATION = '[NOTIFICATION] CREATE_NOTIFICATION';
export const DELETE_NOTIFICATION = '[NOTIFICATION] DELETE_NOTIFICATION';
